/* live open-status chip for the drinks page — same facts as night.js (PHASE0.md) */
(function () {
  'use strict';
  var HOURS = [[16, 24], [16, 24], [16, 26], [16, 26], [16, 26], [16, 26], [11, 26]];
  function fmt12(mins) {
    var h = Math.floor(mins / 60) % 24, m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM', h12 = h % 12 || 12;
    return h12 + ':' + (m < 10 ? '0' + m : m) + ' ' + ap;
  }
  var el = document.getElementById('paperStatus');
  if (!el) return;
  var now = new Date(), day = now.getDay(), t = now.getHours() + now.getMinutes() / 60;
  var todays = HOURS[day], yest = HOURS[(day + 6) % 7];
  var text;
  if (t < 4 && yest[1] > 24 && t + 24 < yest[1]) text = 'open now · til ' + fmt12((yest[1] % 24) * 60);
  else if (t >= todays[0] && t < Math.min(todays[1], 24)) text = 'open now · til ' + fmt12((todays[1] % 24) * 60);
  else if (t < todays[0]) text = 'opens ' + fmt12(todays[0] * 60);
  else text = 'see you tomorrow';
  el.textContent = text;
})();
